<p-dialog
  #modal
  modal="true"
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header" show-close="true">
    <h4>{{ 'events.new.component.title' | translate | titlecase }}</h4>
  </ng-template>
  <div class="container-fluid">
    <div class="form-horizontal">
      <form #newEventForm="ngForm">
        <div class="form-group">
          <div class="col-xs-12">
            <input
              type="text"
              class="form-control"
              name="eventName"
              placeholder="{{ 'events.new.component.event-name-placeholder' | translate }}"
              [(ngModel)]="eventNewParams.EventName"
              required
            />
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-12">
            <ul class="list-inline stack-mobile">
              <li>
                <label>
                  {{ 'events.new.component.event-start-date-label' | translate }}
                </label>
                <div class="wl-give-calendar-right-padding">
                  <wl-date-selector
                    name="startDate"
                    [(ngModel)]="eventNewParams.StartDate"
                    (onDateChanged)="startDateChanged($event)"
                  ></wl-date-selector>
                </div>
              </li>
              <li *ngIf="showStartEndTime">
                <label>
                  {{ 'events.new.component.event-start-time-label' | translate }}
                </label>
                <br />
                <wl-time-selector inputCssClass="form-control" name="startTime" [(ngModel)]="eventNewParams.StartTime"> </wl-time-selector>
              </li>
            </ul>
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-12">
            <ul class="list-inline stack-mobile">
              <li>
                <label>
                  {{ 'events.new.component.event-end-date-label' | translate }}
                </label>
                <div class="wl-give-calendar-right-padding">
                  <wl-date-selector
                    name="endDate"
                    [(ngModel)]="eventNewParams.EndDate"
                    [minDate]="eventNewParams.StartDate"
                    (onDateChanged)="endDateChanged()"
                  ></wl-date-selector>
                </div>
              </li>
              <li *ngIf="showStartEndTime">
                <label>
                  {{ 'events.new.component.event-end-time-label' | translate }}
                </label>
                <wl-time-selector inputCssClass="form-control" name="endTime" [(ngModel)]="eventNewParams.EndTime"></wl-time-selector>
              </li>
            </ul>
          </div>
          <div class="ml-15 mb-15">
            <p-checkbox
              name="isAllDay"
              [(ngModel)]="eventNewParams.IsAllDay"
              [binary]="true"
              inputId="isAllDay"
              (onChange)="allDayChanged($event)"
            >
            </p-checkbox>
            <label for="isAllDay">
              {{ 'events.new.component.event-all-day' | translate }}
            </label>
          </div>
          <div class="ml-15" *ngIf="showSeparateHoursCheckbox">
            <p-checkbox
              name="chkSetSeparateHours"
              [(ngModel)]="displaySeparateHours"
              [binary]="true"
              inputId="chkSetSeparateHours"
              (onChange)="setHoursSeparatelyChanged($event)"
            >
            </p-checkbox>
            <label for="chkSetSeparateHours">
              {{ 'events.new.component.separate-hours-label' | translate | ucfirst }}
            </label>
          </div>
          <div class="ml-15 mv-15" *ngIf="showSeparateHoursSection">
            <wl-events-v4-event-dates-edit [eventDateTimes]="eventNewParams.EventDateTimes"></wl-events-v4-event-dates-edit>
          </div>
        </div>
      </form>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger" [hidden]="!errorMessage">
      {{ errorMessage }}
    </div>
    <wl-busy [show]="saving"></wl-busy>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      [icon]="saving ? '' : 'pi pi-save'"
      [label]="(saving ? 'common.saving' : 'common.save') | translate | titlecase"
      (click)="createEvent($event)"
      [disabled]="!newEventForm.valid || saving"
    ></button>
    <wl-busy [show]="saving"></wl-busy>
    <cancel-button [label]="'common.cancel' | translate | titlecase" [disabled]="saving" (onClick)="newCancel()"> </cancel-button>
  </ng-template>
</p-dialog>
